import classNames from 'classnames';
import { bool, object, string } from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { USER_TYPE } from '../../constants/user.constants';
import * as validators from '../../util/validators';
import FieldTextInput from '../FieldTextInput/FieldTextInput';
import { Heading } from '../Heading/Heading';

import css from './CompanyDetails.module.css';

const CompanyDetails = props => {
  const {
    rootClassName,
    headingClassName,
    className,
    intl,
    disabled,
    formApi,
    fieldId,
    userType,
  } = props;

  const classes = classNames(rootClassName || css.root, className);

  const emailValid = validators.optionalEmailFormatValid(
    intl.formatMessage({
      id: 'CompanyDetails.emailInvalid',
    })
  );

  const vatNumberRequired = validators.required(
    intl.formatMessage({ id: 'CompanyDetails.vatNumberRequired' })
  );

  const vatNumberMaxLength = validators.maxLength(
    intl.formatMessage(
      { id: 'CompanyDetails.vatNumberMaxLength' },
      { length: validators.VAT_NUMBER_MAX_LENGTH }
    ),
    validators.VAT_NUMBER_MAX_LENGTH
  );

  const siteInvalid = validators.validateSimpleUrl(
    intl.formatMessage({
      id: 'CompanyDetails.invalidWebsiteUrl',
    })
  );

  if (userType === USER_TYPE.PRIVATE_SELLER || !userType) return null;

  return (
    <div className={classes}>
      <Heading as="h3" rootClassName={classNames(css.heading, headingClassName)}>
        <FormattedMessage id="CompanyDetails.title" />
      </Heading>
      <FieldTextInput
        id={fieldId ? `${fieldId}.companyName` : 'companyName'}
        name="companyName"
        disabled={disabled}
        type="text"
        autoComplete="company name"
        label={intl.formatMessage({ id: 'CompanyDetails.companyNameLabel' })}
        placeholder={intl.formatMessage({
          id: 'CompanyDetails.companyNamePlaceholder',
        })}
        validate={validators.required(
          intl.formatMessage({ id: 'CompanyDetails.companyNameRequired' })
        )}
        onUnmount={() => formApi.change('companyName', undefined)}
      />
      <FieldTextInput
        id={fieldId ? `${fieldId}.companyVatNumber` : 'companyVatNumber'}
        name="companyVatNumber"
        disabled={disabled}
        type="text"
        className={css.field}
        autoComplete="vat number"
        label={intl.formatMessage({ id: 'CompanyDetails.vatNumberLabel' })}
        placeholder={intl.formatMessage({
          id: 'CompanyDetails.vatNumberPlaceholder',
        })}
        onUnmount={() => formApi.change('companyVatNumber', undefined)}
      />
      <FieldTextInput
        type="email"
        id={fieldId ? `${fieldId}.companyEmail` : 'companyEmail'}
        name="companyEmail"
        autoComplete="company email"
        className={css.field}
        label={intl.formatMessage({
          id: 'CompanyDetails.emailLabel',
        })}
        placeholder={intl.formatMessage({
          id: 'CompanyDetails.emailPlaceholder',
        })}
        validate={emailValid}
        onUnmount={() => formApi.change('companyEmail', undefined)}
      />
      <FieldTextInput
        id={fieldId ? `${fieldId}.companyWebsite` : 'companyWebsite'}
        name="companyWebsite"
        disabled={disabled}
        className={css.field}
        type="text"
        autoComplete="website"
        label={intl.formatMessage({ id: 'CompanyDetails.websiteLabel' })}
        placeholder={intl.formatMessage({
          id: 'CompanyDetails.websitePlaceholder',
        })}
        onUnmount={() => formApi.change('companyWebsite', undefined)}
        validate={siteInvalid}
      />
    </div>
  );
};

CompanyDetails.propTypes = {
  rootClassName: string,
  className: string,
  disabled: bool,
  formApi: object.isRequired,
  fieldId: string,
  intl: object,
};

CompanyDetails.defaultProps = {
  rootClassName: null,
  className: null,
  disabled: false,
  formApi: null,
  fieldId: null,
  intl: null,
};

export default CompanyDetails;
